
const C = {
    AMBIANCE_PHASE: "ambiance",
    FOOD_DRINK_PHASE: "foodDrink",
    NUM_VIDS_PER_PHASE: 3,
    PROGRESS_INTERVAL_MS: 200,
}

export default C;